import React from "react";
import { numberNotation } from "../../../helper/numberStructure";
import "./CardContainer.scss";

const CardContainer = ({ title, total, children }) => {
  return (
    <div className="card">
      <div className="card-wrapper">
        <h2 className="card__main-title title-gray-bold-24">{title}</h2>
        <div className="card-container-children">{children}</div>
        <h2 className="title-gray-bold-24 card-total-price">
          A$ {numberNotation(total)}
        </h2>
      </div>
    </div>
  );
};

export default CardContainer;
